angular.module("app").constant("toolsMap", {
    "published": {
        inactiveToggle: {
            title: "Inactive",
            class: "published",
            action: 'toggleInactive'
        },
        publishToggle: {
            title: "Delete",
            class: "published",
            action: 'delete'
        },
        editToggle: {
            title: "Edit"
        },
        previewToggle: {
            title: "Preview"
        }
    },
    "inactive": {
        inactiveToggle: {
            title: "Publish",
            class: "inactive",
            action: 'toggleInactive'
        },
        publishToggle: {
            title: "Delete",
            class: "published",
            action: 'delete'
        },
        editToggle: {
            title: "Edit"
        },
        previewToggle: {
            title: "Preview"
        }
    },
    "archive": {
        inactiveToggle: {
            title: "Inactive",
            class: "published",
            action: 'toggleInactive'
        },
        publishToggle: {
            title: "Publish",
            class: "archive",
            action: 'toggleInactive'
        },
        editToggle: {
            title: "Edit"
        },
        previewToggle: {
            title: "Preview"
        }
    },
    "expired": {
        inactiveToggle: {
            title: "Inactive",
            class: "published",
            action: 'toggleInactive'
        },
        publishToggle: {
            title: "Delete",
            class: "published",
            action: 'delete'
        },
        editToggle: {
            title: "Edit"
        },
        previewToggle: {
            title: "Preview"
        }
    }
});